import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";
import {
  HardwareAdapterConfigurationDto,
  HardwareConfigurationPayload,
} from "../../../models/api/hardwareAdapterConfigurationDto";
import { ApiErrorHandlerService } from "../../utils/api-error-handler/api-error-handler.service";

@Injectable({
  providedIn: "root",
})
export class HardwareAdapterService {
  private readonly http = inject(HttpClient);
  private readonly apiErrorHandler = inject(ApiErrorHandlerService);

  public getHardwareConfiguration(gateSystemId: string): Observable<HardwareAdapterConfigurationDto[]> {
    return this.http
      .get<HardwareAdapterConfigurationDto[]>(`${environment.baseUrl}/gateSystem/${gateSystemId}/hardwareAdapter`)
      .pipe(this.apiErrorHandler.handle("hardware_adapter"));
  }

  public editHardwareConfiguration(
    gateSystemId: string,
    hardwareConfigurationPayload: HardwareConfigurationPayload[]
  ): Observable<HardwareAdapterConfigurationDto[]> {
    return this.http
      .put<
        HardwareAdapterConfigurationDto[]
      >(`${environment.baseUrl}/gateSystem/${gateSystemId}/hardwareAdapter`, hardwareConfigurationPayload)
      .pipe(this.apiErrorHandler.handle("hardware_adapter"));
  }
}
